import * as React from 'react';
import {cn} from '../lib/cn';

export function EmptyHeader({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="empty-header"
      className={cn('flex max-w-sm flex-col items-center gap-2 text-center', className)}
      {...props}
    />
  );
}
